import {NgModule} from '@angular/core';
import {CtrlTextboxComponent} from './ctrl-textbox.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MAT_DATE_LOCALE, MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {provideMomentDateAdapter} from '@angular/material-moment-adapter';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSliderModule} from '@angular/material/slider';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTimepickerModule} from '@angular/material/timepicker';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CtrlLabelComponent} from './ctrl-label.component';
import {CtrlDatetimeComponent} from './ctrl-datetime.component';
import {CtrlSliderComponent} from './ctrl-slider.component';
import {CtrlDropdownComponent} from './ctrl-dropdown.component';
import {CtrlRadiobuttonsComponent} from './ctrl-radiobuttons.component';
import {CtrlCheckboxComponent} from './ctrl-checkbox.component';
import {CtrlFileuploadComponent} from './ctrl-fileupload.components';
import {UniqueValueValidatorDirective} from './validators/unique-validator.directive';
import {LanguageModule} from '../../../language/language.module';
import {CtrlSimpleRadiobuttonsComponent} from './ctrl-simpleradiobuttons.component';
import {CtrlIdentitypickerSingleComponent} from './ctrl-identitypicker-single.component';
import {CtrlNumericBoxComponent} from './ctrl-numericbox.component';
import {CtrlHyperLinkComponent} from './ctrl-hyperlink.component';
import {CtrlCaptionControlComponent} from './ctrl-captioncontrol.component';
import {CtrlListviewComponent} from './ctrl-listview.component';
import {ComponentsModule} from '../../../shared/component/components.module';
import {MultivalueDialogComponent} from './multivalue-dialog/multivalue-dialog.component';
import {ResourceComponent} from '../../resource.component';
import {CtrlIdentitypickerMultiComponent} from './ctrl-identitypicker-multi.component';
import {CtrlDataComponent} from './ctrl-data';
import {CtrlColorpickerComponent} from './ctrl-colorpicker.component';
import {CtrlFileDownloadComponent} from './ctrl-filedownload.component';
import {CtrlPictureBoxComponent} from './ctrl-picturebox.component';
import {CtrlCommonMultiValueControlComponent} from './ctrl-commonmultivalue.component';
import {CtrlMarkdownAreaComponent} from './ctrl-markdownarea.component';
import {CtrlFilterbuilderComponent} from './ctrl-filterbuilder.component';
import {CtrlActionBarComponent} from './ctrl-actionbar.component';
import {CtrlMultiselectComponent} from './ctrl-multiselect.component';
import {CtrlRequestSummary} from './ctrl-requestsummary';
import {SharedControlsModule} from '../../../shared/controls/controls.module';
import {CtrlProcessDesignerComponent} from './processdesigner/ctrl-processdesigner.component';
import {CtrlConnectedSystemScopeComponent} from './synchronization/ctrl-connected-system-scope.component';
import {CtrlSyncruleParameterComponent} from './synchronization/ctrl-syncrule-parameter.component';
import {CtrlRelationshipCriteriaComponent} from './synchronization/ctrl-relationship-criteria.component';
import {CtrlInboundAttributeFlowComponent} from './synchronization/ctrl-inbound-attribute-flow.component';
import {AttributeFlowConstantDialog} from './synchronization/attribute-flow-constant-dialog.component';
import {AttributeFlowCustomExpressionDialog} from './synchronization/attribute-flow-custom-expression-dialog.component';
import {AttributeFlowFunctionDialog} from './synchronization/attribute-flow-function-dialog.component';
import {PipesModule} from '../../../shared/pipes/pipes.module';
import {CtrlOutboundAttributeFlowComponent} from './synchronization/ctrl-outbound-attribute-flow.component';
import {CtrlInitialAttributeFlowComponent} from './synchronization/ctrl-initial-attribute-flow.component';
import {AttributeFlowDestinationComponent} from './synchronization/attribute-flow-destination.component';
import {FileDropModule} from '../../../shared/component/id-file-drop';
import {CtrlModuleSyncComponent} from './ctrl-modulesync.component';
import {CommonModule} from '@angular/common';
import {CtrlIconComponent} from './ctrl-icon.component';
import {LanguageService} from '../../../language/language.service';
import {
  AppDialogComponent,
  AppDialogHeaderButtonDirective,
  AppDialogTitleDirective,
} from '../../../shared/dialog/app-dialog.component';
import {CtrlAttributeFlowTitleComponent} from './synchronization/attribute-flow-components';

@NgModule({
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    MatTimepickerModule,
    FormsModule,
    ReactiveFormsModule,
    LanguageModule,
    ComponentsModule,
    FileDropModule,
    SharedControlsModule,
    PipesModule,
    AppDialogComponent,
    AppDialogTitleDirective,
    AppDialogHeaderButtonDirective,
    CtrlAttributeFlowTitleComponent,
  ],
  declarations: [
    CtrlTextboxComponent,
    CtrlLabelComponent,
    CtrlDatetimeComponent,
    CtrlSliderComponent,
    CtrlDropdownComponent,
    CtrlMultiselectComponent,
    CtrlRadiobuttonsComponent,
    CtrlSimpleRadiobuttonsComponent,
    CtrlCheckboxComponent,
    CtrlIdentitypickerSingleComponent,
    CtrlIdentitypickerMultiComponent,
    CtrlFileuploadComponent,
    CtrlFileDownloadComponent,
    CtrlPictureBoxComponent,
    CtrlNumericBoxComponent,
    CtrlHyperLinkComponent,
    CtrlActionBarComponent,
    CtrlCaptionControlComponent,
    CtrlListviewComponent,
    CtrlDataComponent,
    CtrlCommonMultiValueControlComponent,
    CtrlMarkdownAreaComponent,
    CtrlFilterbuilderComponent,
    UniqueValueValidatorDirective,
    MultivalueDialogComponent,
    CtrlRequestSummary,
    CtrlProcessDesignerComponent,
    CtrlConnectedSystemScopeComponent,
    CtrlSyncruleParameterComponent,
    CtrlRelationshipCriteriaComponent,
    CtrlInboundAttributeFlowComponent,
    CtrlOutboundAttributeFlowComponent,
    CtrlInitialAttributeFlowComponent,
    CtrlColorpickerComponent,
    CtrlModuleSyncComponent,
    CtrlIconComponent,
    AttributeFlowConstantDialog,
    AttributeFlowCustomExpressionDialog,
    AttributeFlowFunctionDialog,
    AttributeFlowDestinationComponent,
  ],
  providers: [
    ResourceComponent,
    {provide: MAT_DATE_LOCALE, useValue: LanguageService.getBrowserLanguage()},
    provideMomentDateAdapter({
      parse: {
        dateInput: ['L', 'LL', 'YYYY-MM-DD'],
        timeInput: ['LT'],
      },
      display: {
        dateInput: 'L',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
        timeInput: 'LT',
        timeOptionLabel: 'LT',
      },
    }),
  ],
  exports: [
    CtrlTextboxComponent,
    CtrlLabelComponent,
    CtrlDatetimeComponent,
    CtrlSliderComponent,
    CtrlDropdownComponent,
    CtrlMultiselectComponent,
    CtrlRadiobuttonsComponent,
    CtrlSimpleRadiobuttonsComponent,
    CtrlCheckboxComponent,
    CtrlIdentitypickerSingleComponent,
    CtrlIdentitypickerMultiComponent,
    CtrlFileuploadComponent,
    CtrlFileDownloadComponent,
    CtrlPictureBoxComponent,
    CtrlNumericBoxComponent,
    CtrlHyperLinkComponent,
    CtrlActionBarComponent,
    CtrlCaptionControlComponent,
    CtrlListviewComponent,
    CtrlDataComponent,
    CtrlCommonMultiValueControlComponent,
    CtrlMarkdownAreaComponent,
    CtrlFilterbuilderComponent,
    MultivalueDialogComponent,
    CtrlRequestSummary,
    CtrlProcessDesignerComponent,
    CtrlConnectedSystemScopeComponent,
    CtrlSyncruleParameterComponent,
    CtrlRelationshipCriteriaComponent,
    CtrlInboundAttributeFlowComponent,
    CtrlOutboundAttributeFlowComponent,
    CtrlInitialAttributeFlowComponent,
    CtrlModuleSyncComponent,
    AttributeFlowConstantDialog,
    AttributeFlowCustomExpressionDialog,
    AttributeFlowFunctionDialog,
    AttributeFlowDestinationComponent,
    CtrlColorpickerComponent,
    CtrlIconComponent,
  ],
})
export class ControlsModule {}
